module.exports = __webpack_public_path__ + "img/House.540a3b7d.svg";